export default __webpack_public_path__ + "static/media/Purple-Cake.7b66c9a6.jpg";